export default __webpack_public_path__ + "static/media/industrial-safco.9a2dfccb.jpg";